import React, { useMemo, useState, useRef, useEffect } from 'react';
import { useTable, usePagination, useSortBy } from 'react-table';
import '../../../styles/globalStyle.css';
import downIcon from '../../../assets/Polygon 2.png';
import upIcon from '../../../assets/Polygon 3.png';
import disable from '../../../assets/Frame 263.png'
import threeDotsIcon from "../../../assets/dots-vertical.png"
import { useDispatch, useSelector } from 'react-redux';
import { UpdateBusinessStatus } from '../../../services/operations/AdminPageAPI';

const Table = ({ data = [], pagination, fetchRecruiters, onPageChange }) => {

    const [dropdownOpen, setDropdownOpen] = useState(null);
    const token = useSelector((state) => state.auth.token);
    const loading=useSelector((state)=>state.auth.loading)
    const dropdownRef = useRef(null);

    const dispatch = useDispatch();

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownOpen(null);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);


    const handleUpdateBusinessStatus = async (id, status) => {

        const payload = {
            id: id,
            is_active: status

        }
        await dispatch(UpdateBusinessStatus(token, payload))
        fetchRecruiters();

    }
    const columns = useMemo(
        () => [
            { Header: 'Business Name', accessor: 'company_name', disableSortBy: true },
            { Header: 'Owner Name', accessor: 'name', disableSortBy: true },
            { Header: 'Email', accessor: 'email', disableSortBy: true },
            { Header: 'Team Members', accessor: 'team_member_count', disableSortBy: true },
            { Header: 'Subscription Status', accessor: 'subscription_status', disableSortBy: true },
            {
                Header: 'Last Payment Date',
                accessor: 'last_payment_date',
                disableSortBy: true
            },
            { Header: 'Amount', accessor: 'amount', disableSortBy: true },
            {
                Header: 'Actions',
                accessor: 'actions',
                Cell: ({ row }) => (
                    <div className="actions">
                        <img
                            src={threeDotsIcon}
                            alt="Actions"
                            className="three-dots-icon"
                            onClick={(e) => {
                                console.log("ddd", row)
                                e.stopPropagation();
                                setDropdownOpen(dropdownOpen === row.id ? null : row.id);

                            }}
                        />
                        {dropdownOpen === row.id && (
                            <div className="dropdown-menu-status" ref={dropdownRef}>
                                {row.original.subscription_status?.toLowerCase() === "active" ? (
                                    <div className="dropdown-item-status"
                                        onClick={() => handleUpdateBusinessStatus(row.original.business_id, false)}>
                                        <img src={disable} alt="delete" width={20} height={20} />Deactivate Business
                                    </div>
                                ) : (
                                    <div className="dropdown-item-status"
                                        onClick={() => handleUpdateBusinessStatus(row.original.business_id, true)}>
                                        <img src={""} alt="edit" width={20} height={20} />Activate Business
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                ),
                disableSortBy: true,
            },
        ],
        [dropdownOpen]
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        page,
    } = useTable(
        {
            columns,
            data,
            initialState: { pageIndex: pagination.current_page - 1 },
            manualPagination: true,
            pageCount: pagination.total_pages,
        },
        usePagination
    );

    const renderPagination = () => {
        const { current_page, total_pages } = pagination || {};
        const pageNumbers = [];

        if (!total_pages) return null;

        if (total_pages <= 5) {
            for (let i = 1; i <= total_pages; i++) {
                pageNumbers.push(
                    <button
                        key={i}
                        className={`page-btn ${i === current_page ? 'active' : ''}`}
                        onClick={() => onPageChange(i)}
                    >
                        {i}
                    </button>
                );
            }
        } else {
            pageNumbers.push(
                <button
                    key={1}
                    className={`page-btn ${1 === current_page ? 'active' : ''}`}
                    onClick={() => onPageChange(1)}
                >
                    1
                </button>
            );

            if (current_page > 3) pageNumbers.push(<span key="dots1">...</span>);
            const startPage = Math.max(2, current_page - 1);
            const endPage = Math.min(total_pages - 1, current_page + 1);

            for (let i = startPage; i <= endPage; i++) {
                pageNumbers.push(
                    <button
                        key={i}
                        className={`page-btn ${i === current_page ? 'active' : ''}`}
                        onClick={() => onPageChange(i)}
                    >
                        {i}
                    </button>
                );
            }
            if (current_page < total_pages - 2) pageNumbers.push(<span key="dots2">...</span>);
            pageNumbers.push(
                <button
                    key={total_pages}
                    className={`page-btn ${total_pages === current_page ? 'active' : ''}`}
                    onClick={() => onPageChange(total_pages)}
                >
                    {total_pages}
                </button>
            );
        }

        return (
            <div className='pagination-container' style={{ justifyContent: "flex-end" }}>
                <div style={{ display: "flex", gap: "10px" }}>
                    <button
                        className={`page-btn ${current_page === 1 ? 'disabled' : ''}`}
                        onClick={() => onPageChange(current_page - 1)}
                        disabled={current_page === 1}
                    >
                        Prev
                    </button>
                    {pageNumbers}
                    <button
                        className={`page-btn ${current_page === total_pages ? 'disabled' : ''}`}
                        onClick={() => onPageChange(current_page + 1)}
                        disabled={current_page === total_pages}
                    >
                        Next
                    </button>
                </div>
            </div>
        );
    };

    return (
        <>
            {renderPagination()}
            <table {...getTableProps()} className="data-table">
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th {...column.getHeaderProps()}>
                                    <div className="header-content">
                                        {column.render('Header')}

                                    </div>
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {loading ? (
                        [...Array(15)].map((_, index) => (
                            <tr key={index}>
                                <td colSpan={columns.length} style={{ padding: '20px' }}>
                                    <div className="skeleton-row"></div>
                                </td>
                            </tr>
                        ))
                    ) : data.length === 0 ? (
                        <tr>
                            <td colSpan={columns.length} style={{ textAlign: 'center', padding: '20px' }}>
                                No data to display
                            </td>
                        </tr>
                    ) : (
                        page.map((row) => {
                            prepareRow(row);
                            return (
                                <tr {...row.getRowProps()}>
                                    {row.cells.map((cell) => (
                                        <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                                    ))}
                                </tr>
                            );
                        })
                    )}
                </tbody>

            </table>
            {renderPagination()}
        </>
    );
};

export default Table;
